import { api } from './client';

const BASE_URL = "/packages/";

export const getPackages = async (page = 1, pageSize = 10, tripId = null) => {
  const params = {
    page,
    page_size: pageSize,
  };
  if (tripId) {
    params.trip = tripId;
  }

  return api.get("/packages/", { params });
};

export const createPackage = (payload) => api.post(BASE_URL, payload);

export const deletePackage = (id) => api.delete(`${BASE_URL}${id}/`);
